import angular from 'angular';
import { BootstrapWidgets, CurrentUser, Endpoints, Lang, ThumbnailView, ThumbnailMetrics } from 'Roblox';
import avatarBodyColorDifference from '../../../jquery/avatar/avatarBodyColorDifference';
import avatarModule from '../avatarModule';

/*
    Controls the avatar page
    Provides some functions in $scope that are used by various child controllers
*/
function avatarController(
  $scope,
  $log,
  $timeout,
  $q,
  $rootScope,
  avatarService,
  avatarConstantService,
  avatarUrlConstants,
  avatarAssetTypeNames,
  $anchorScroll,
  googleAnalyticsEventsService,
  urlService,
  $uibModal,
  modalService,
  $window,
  languageResource,
  avatarTypeService,
  thumbnailService,
  thumbnailConstants,
  localStorageService
) {
  'ngInject';

  const lang = languageResource;
  $log.debug('avatarController starting');

  $scope.pageLoaded = false;
  $scope.bundlesEnabledForUser = false;
  $scope.emotesEnabledForUser = false;
  let outfitCostumeMessage = avatarConstantService.outfits.outfitMessages;

  $scope.selectedCategory = null;
  $scope.selectedSubcategory = null;
  $scope.categoryDict = {};
  $scope.subcategoryDict = {};

  // Scale tab is being moved to a tab
  $scope.displayScalePlaceholder = true;
  $scope.displayPackagePlaceholder = true;
  let scalingLocalStorageKey = 'Roblox.AvatarScale.MovedToTab';
  let packageLocalStorageKey = 'Roblox.PackageScale.MovedToTab';
  let presetCostumeDelayLocalStorageKey = 'Roblox.PresetCostumes.InitialDelay';

  $scope.createUrl = '/develop?directLink=1&view=';
  $scope.shirtId;
  $scope.tShirtId;
  $scope.pantsId;

  function isLocalStorageKeyTrue(localStorageKey) {
    if (!$window.localStorage) {
      return false;
    }
    const stored = $window.localStorage.getItem(localStorageKey);
    if (stored === 'true') {
      return true;
    }
    return false;
  }

  function setLocalStorageKey(localStorageKey) {
    if (!$window.localStorage) {
      return;
    }
    $window.localStorage.setItem(localStorageKey, 'true');
  }

  if (isLocalStorageKeyTrue(scalingLocalStorageKey)) {
    $scope.displayScalePlaceholder = false;
  }
  if (
    isLocalStorageKeyTrue(packageLocalStorageKey) ||
    ($scope.avatarDataModel !== undefined && !$scope.avatarDataModel.bundlesEnabledForUser)
  ) {
    $scope.displayPackagePlaceholder = false;
  }

  // System Feedback

  $scope.systemFeedback = {
    error(message, timeout) {
      if (typeof timeout === 'undefined') {
        timeout = 2000;
      }
      BootstrapWidgets.ToggleSystemMessage($('.alert-warning'), 100, timeout, message);
    },
    loading(message) {
      BootstrapWidgets.ToggleSystemMessage($('.alert-loading'), 100, 2000, message);
    },
    success(message) {
      BootstrapWidgets.ToggleSystemMessage($('.alert-success'), 100, 2000, message);
    },
    info(message) {
      BootstrapWidgets.ToggleSystemMessage($('.alert-info'), 100, 2000, message);
    }
  };

  // Thumbnail
  $scope.isThumbnailLoading = false;
  $scope.refreshThumbnail = function() {
    // clear thumbnail service cache and hard re-render
    // thumbnail-2d component.
     $scope.isThumbnailLoading = true;
    return thumbnailService.reloadThumbnailImage(
      thumbnailConstants.thumbnailTypes.avatar,
      $scope.avatarDataModel.userId,
      thumbnailConstants.thumbnailAvatarsSize.size352
    ).finally(()=>{
       $scope.isThumbnailLoading = false;
    });
  };

  $scope.redrawFloodchecked = false;
  $scope.redrawThumbnail = function() {
    avatarService.redrawThumbnail().then(
      function success() {
        $scope.refreshThumbnail();
      },
      function error(data) {
        let floodchecked = data && data.errors && data.errors[0] && data.errors[0].code === 1;
        if (floodchecked) {
          $scope.systemFeedback.error(avatarConstantService.thumbnail.redrawFloodchecked);
          $log.debug('Disabled redraw button');
          $scope.redrawFloodchecked = true;
          $timeout(function() {
            $log.debug('Re-enabled redraw');
            $scope.redrawFloodchecked = false;
          }, avatarConstantService.thumbnail.waitForThumbnailRegenerationInSeconds * 1000);
        } else {
          $scope.systemFeedback.error(avatarConstantService.thumbnail.redrawThumbnailFailed);
        }
      }
    );
  };
  // Avatar 3D toggle
  $scope.threeDToggleData = {
    is3d: false,
    avatarToggleButton: avatarConstantService.thumbnail.threeDeeButton 
  }

  const syncAvatarButton = () => {
    $scope.threeDToggleData.avatarToggleButton = $scope.threeDToggleData.is3d ?
      avatarConstantService.thumbnail.twoDeeButton : avatarConstantService.thumbnail.threeDeeButton;
  }

  $scope.toggleThreeDee = () => {
    $scope.threeDToggleData.is3d = !$scope.threeDToggleData.is3d;
    localStorageService.setLocalStorage(avatarConstantService.thumbnail.useThreeDeeThumbsKey, $scope.threeDToggleData.is3d);
    syncAvatarButton();
  }

  const initializeThreeDeeButton = () => {
    $scope.threeDToggleData.is3d = localStorageService.getLocalStorage(
      avatarConstantService.thumbnail.useThreeDeeThumbsKey
    );

    syncAvatarButton();
  }

  initializeThreeDeeButton();
  // Avatar Loading

  let avatarRules = null;
  let avatarDetails = null;

  const assetTypeLookup = {};
  const assetTypeNameLookup = {};

  $scope.loadAvatarDetailsSuccessCallBack = function(result) {
    $log.debug('Retrieved avatar details');
    avatarDetails = result;
    setCurrentlyWornAssets(avatarDetails.assets);
    updateSelection();
    $scope.$broadcast(avatarConstantService.events.avatarDetailsLoaded, avatarDetails);
  };
  function loadAvatarDetails() {
    const request = avatarService.getAvatar();
    request.then(function success(result) {
      $scope.loadAvatarDetailsSuccessCallBack(result);
    });
    return request;
  }

  $scope.loadRulesSuccessCallBack = function(result) {
    $log.debug('Retrieved avatar rules');
    avatarRules = result;
    $scope.bundlesEnabledForUser = avatarRules.bundlesEnabledForUser;
    $scope.emotesEnabledForUser = avatarRules.emotesEnabledForUser;
    outfitCostumeMessage = $scope.bundlesEnabledForUser
      ? avatarConstantService.outfits.costumeMessages
      : avatarConstantService.outfits.outfitMessages;
    $scope.$broadcast(avatarConstantService.events.avatarRulesLoaded, avatarRules);

    // add package
    const packageType = {
      id: 32,
      name: 'Package',
      maxCount: 0
    };
    avatarRules.wearableAssetTypes.push(packageType);

    if ($scope.emotesEnabledForUser) {
      avatarTypeService.setAssetTypeLookups(avatarRules.wearableAssetTypes);
    } else {
      // TODO: clean up after emotes is released
      angular.forEach(avatarRules.wearableAssetTypes, function(assetType) {
        assetTypeLookup[assetType.id] = assetType;
        assetTypeNameLookup[assetType.name] = assetType;
      });
    }
  };

  function getAssetType(id) {
    if ($scope.emotesEnabledForUser) {
      return avatarTypeService.assetTypeLookup[id];
    }
    return assetTypeLookup[id];
  }

  $scope.getAssetTypeName = function(id) {
    if ($scope.emotesEnabledForUser) {
      return avatarTypeService.getAssetTypeName(id);
    } 
      let assetType = getAssetType(id);
      return assetType && assetType.name ? assetType.name : null;
    
  };

  $scope.getAssetTypeByName = function(name) {
    if ($scope.emotesEnabledForUser) {
      return avatarTypeService.getAssetTypeByName(name);
    } 
      let assetType = assetTypeNameLookup[name];
      return assetType;
    
  };

  $scope.onDismissScalingDialog = function() {
    $scope.displayScalePlaceholder = false;
    setLocalStorageKey(scalingLocalStorageKey);
  };
  $scope.onDismissPackageDialog = function() {
    $scope.displayPackagePlaceholder = false;
    setLocalStorageKey(packageLocalStorageKey);
  };

  const getAvatarSuccessCallback = (avatarType) => {
    return ({ duration })=> ThumbnailMetrics && ThumbnailMetrics.logFinalThumbnailTime(duration, avatarType);
  };

  const getAvatarFailureCallback = (avatarType) => {
    return ()=> ThumbnailMetrics && ThumbnailMetrics.logThumbnailTimeout(avatarType);
  };

  $scope.initializeAvatarThumbnail = function() {
    $scope.avatarDataModel.thumbnailCacheKey = '';
    $scope.avatarDataModel.thumbnailType = thumbnailConstants.thumbnailTypes.avatar;
    $scope.avatarDataModel.thumbnailOptions = { size: thumbnailConstants.thumbnailAvatarsSize.size352 };
    $scope.avatarDataModel.on2dAvatarSuccess = getAvatarSuccessCallback('2dThumbnailOnLoad');
    $scope.avatarDataModel.on3dAvatarSuccess = getAvatarSuccessCallback('3dThumbnail');
    $scope.avatarDataModel.on2dAvatarFailure = getAvatarFailureCallback('2dThumbnailOnLoad');
    $scope.avatarDataModel.on3dAvatarFailure = getAvatarFailureCallback('3dThumbnail');
  };

  $scope.initializePage = function() {
    if ($scope.avatarDataModel.isAvatarScaleEmbeddedInTab === true) {
      angular.forEach($scope.tabs, function(tab) {
        if (tab.name === 'Body') {
          angular.forEach(tab.categoryRows, function(row) {
            if (row.name === 'Appearance') {
              angular.forEach(row.subCategoryMenu, function(menu) {
                if (menu.name === 'Scale') {
                  menu.visible = true;
                }
              });
            }
          });
        }
      });
    }
    if ($scope.emotesEnabledForUser) {
      angular.forEach($scope.tabs, function(tab) {
        if (tab.name === 'AvatarAnimations') {
          angular.forEach(tab.subCategoryMenu, function(menu) {
            if (menu.name === 'Emote') {
              menu.visible = true;
            }
          });
        }
      });
    }
    if ($scope.bundlesEnabledForUser === true) {
      angular.forEach($scope.tabs, function(tab) {
        if (tab.name === 'Outfits') {
          tab.visible = false;
        }
        if (tab.name === 'Costumes') {
          tab.visible = true;
        }
        if (tab.name === 'Recent') {
          angular.forEach(tab.subCategoryMenu, function(menu) {
            if (menu.name === 'Outfits') {
              menu.label = lang.get('Label.Costume');
            }
          });
        }
        if (tab.name === 'Body') {
          angular.forEach(tab.categoryRows, function(row) {
            if (row.name === 'Packages') {
              row.visible = false;
            }
          });
        }
      });
    }
  };

  $scope.buildAvatarDataModel = function(metaData, thumbnailData) {
    angular.extend($scope.avatarDataModel, metaData);
    $scope.avatarDataModel.userId = CurrentUser.userId;
    $scope.avatarDataModel.catalogPageUrl = urlService.getAbsoluteUrl('/catalog');
  };

  function getCreateUrlAssetTypeIds() {
    let shirtAssetType = $scope.getAssetTypeByName('Shirt');
    let tShirtAssetType = $scope.getAssetTypeByName('T-Shirt');
    let pantsAssetType = $scope.getAssetTypeByName('Pants');
    $scope.shirtId = shirtAssetType !== null ? shirtAssetType.id : '';
    $scope.tShirtId = tShirtAssetType !== null ? tShirtAssetType.id : '';
    $scope.pantsId = pantsAssetType !== null ? pantsAssetType.id : '';
  }

  function loadAvatarPageCallBackSuccess(result) {
    $log.debug('Retrieved avatar rules and details and metaData');
    const loadRulesResult = result[0];
    const getAvatarRequestResult = result[1];
    const getMetaDataRequestResult = result[2];
    const avatarThumbnailResult = result[3];

    $scope.buildAvatarDataModel(getMetaDataRequestResult, avatarThumbnailResult);
    $scope.loadRulesSuccessCallBack(loadRulesResult);
    getCreateUrlAssetTypeIds();
    $scope.initializePage();
    $scope.loadAvatarDetailsSuccessCallBack(getAvatarRequestResult);
    $scope.avatarLibrary = {
      avatarRules: loadRulesResult,
      avatarDetails: getAvatarRequestResult,
      metaData: getMetaDataRequestResult
    };

    $scope.pageLoaded = true;
    ThumbnailView.setupDelayedThumbnailHolders();
    $scope.$broadcast(avatarConstantService.events.pageLoaded, {
      avatarRules: loadRulesResult,
      avatarDetails: getAvatarRequestResult,
      metaData: getMetaDataRequestResult
    });
  }

  function getAvatarThumbnail() {
    $scope.initializeAvatarThumbnail();
  }

  function loadAvatarPageCallBackError() {
    const getRulesRequest = avatarService.getRules();
    const getAvatarRequest = avatarService.getAvatar();
    const getaMetaDataRequest = avatarService.getMetaData();
    getaMetaDataRequest.then(ThumbnailView.setupDelayedThumbnailHolders()); // prevent thumbnail not loaded if other callback is failed
    const result = [getRulesRequest, getAvatarRequest, getaMetaDataRequest, getAvatarThumbnail()];
    $scope.systemFeedback.error(avatarConstantService.page.errorLoadingPage, 60000);
    $q.all(result).then(loadAvatarPageCallBackSuccess);
  }
  $scope.loadAvatarPage = function() {
    const getRulesRequest = avatarService.getRules();
    const getAvatarRequest = avatarService.getAvatar(false);
    const getMetaDataRequest = avatarService.getMetaData(false);
    $scope.avatarDataModel = {
      userId: CurrentUser.userId,
      scaleEnabled: false
    };
    getSubcategories();
    getCategories();
    getMetaDataRequest.then(ThumbnailView.setupDelayedThumbnailHolders()); // prevent thumbnail not loaded if other callback is failed
    $q.all([getRulesRequest, getAvatarRequest, getMetaDataRequest, getAvatarThumbnail()]).then(
      loadAvatarPageCallBackSuccess,
      loadAvatarPageCallBackError
    );
  };

  // / Navigation
  $scope.tabs = avatarConstantService.tabs;
  $scope.selectedTab = null;
  $scope.selectedMenu = null;
  $scope.selectedCategory = null;
  $scope.selectedSubcategory = null;
  $scope.tabWithOpenMenu = null;
  $scope.isMenuOpen = false;

  function hasClickOpenedTab() {
    return $scope.tabWithOpenMenu && $scope.tabWithOpenMenu.active;
  }

  $scope.mouseLeftTabMenu = function() {
    if (hasClickOpenedTab()) {
      return;
    }
    $scope.tabWithOpenMenu = null;
    $scope.isMenuOpen = false;
  };

  $scope.onTabBlur = function(tab) {
    $scope.tabWithOpenMenu = null;
    $scope.isMenuOpen = false;
  };

  $scope.onTabClick = function(tab) {
    if (tab.noSubCategoryMenu) {
      $scope.onMenuClick(tab, null);
    } else {
      // clicked on tab with drop down
      // keep it open until next action

      // clicked on tab that already has menu clicked open

      if (hasClickOpenedTab()) {
        if ($scope.tabWithOpenMenu === tab) {
          // clicked on same tab that is already clicked open
          $scope.tabWithOpenMenu = null;
          $scope.isMenuOpen = false;
          tab.active = false;
          return;
        } 
          // clicked on other tab
          $scope.tabWithOpenMenu.active = false;
          $scope.tabWithOpenMenu = tab;
          $scope.isMenuOpen = true;
          tab.active = true;
          return;
        
      }

      // tab is open due to hover, clicking will "lock" it open
      $scope.isMenuOpen = true;
      $scope.tabWithOpenMenu = tab;
      tab.active = true;
    }
  };

  $scope.onTabHover = function(tab) {
    if (hasClickOpenedTab()) {
      return;
    }
    $scope.tabWithOpenMenu = tab;
    $scope.isMenuOpen = true;
  };

  $scope.scrollToTop = function() {
    let isBelowTopOfPage = angular.element('#wrap').hasClass('pinned');
    if (isBelowTopOfPage) {
      $anchorScroll('tab-content-top');
    }
  };

  $scope.onMenuClick = function(tab, menu, categoryRow) {
    $scope.isMenuOpen = false;
    $scope.tabWithOpenMenu = null;
    $scope.selectedTab = tab;
    $scope.selectedMenu = menu;

    if (menu !== null && menu.name === 'PresetCostumes') {
      if (!isLocalStorageKeyTrue(presetCostumeDelayLocalStorageKey)) {
        // This message only gets displayed once, so cache that the message was already displayed once
        $scope.displayPresetCostumeDelayMessage = true;
        setLocalStorageKey(presetCostumeDelayLocalStorageKey);
      }
    } else {
      $scope.displayPresetCostumeDelayMessage = false;
    }

    $scope.selectedCategory =
      categoryRow !== null && categoryRow !== undefined ? categoryRow.name : tab.name;
    $scope.selectedSubcategory = menu === null ? '' : menu.name;

    $scope.scrollToTop();

    updateAdvancedAccessoriesLinkVisibility();
    $scope.$broadcast(avatarConstantService.events.menuClicked, { tab, menu });
    googleAnalyticsEventsService.viewVirtual(
      `${avatarUrlConstants.www.avatar  }/${  tab.name  }${menu === null ? '' : '/' + menu.name}`
    );
  };

  // / Outfits

  $scope.openOutfitMenu = function(item) {
    item.active = true;
  };

  $scope.closeOutfitMenu = function(item) {
    if (item.active) {
      item.active = false;
    }
  };

  $scope.onItemMenuButtonClicked = function($event, item, option) {
    item.active = false;

    switch (option.name) {
      case 'Delete':
        openOutfitDeleteModal(item);
        break;
      case 'Update':
        openOutfitUpdateModal(item);
        break;
      case 'Rename':
        openOutfitRenameModal(item);
        break;
    }
  };

  $scope.openEmotesModal = function(selectedItem) {
    const modalParams = {
      animation: false,
      templateUrl: avatarUrlConstants.modals.emotes.templateUrl,
      controller: avatarUrlConstants.modals.emotes.controllerName,
      openedClass: '',
      size: 'md',
      windowClass: 'emotes-modal',
      resolve: {
        modalData: {
          assetTypeInfo: avatarTypeService.getAssetTypeByName([
            avatarConstantService.emotes.assetType
          ]),

          // Variables for avatar items grid in emotes modal
          isMenuOpen: $scope.isMenuOpen,
          selectedTab: $scope.selectedTab,
          selectedMenu: $scope.selectedMenu,
          selectedCategory: $scope.selectedCategory,
          selectedSubcategory: $scope.selectedSubcategory,

          // Functions for avatar items grid in emotes modal
          addItemThumbnailAndLink: $scope.addItemThumbnailAndLink,
          systemFeedback: $scope.systemFeedback,

          // Special information for the emotes modal
          selectedItem
        }
      }
    };
    $uibModal.open(modalParams).result.then(function(data) {});
  };

  $scope.outfitMenuOptions = avatarConstantService.outfits.menuOptions;

  $scope.createOutfitClicked = function() {
    openOutfitCreateModal();
  };

  function hasInvalidOutfitName(data) {
    let invalidOutfitName = false;
    if (data && data.errors) {
      for (let i = 0; i < data.errors.length; i++) {
        if (
          data.errors[i].code === avatarConstantService.outfits.outfitErrorCodes.invalidOutfitName
        ) {
          invalidOutfitName = true;
        }
      }
    }
    return invalidOutfitName;
  }

  function outfitNameModalCallback(outfitName) {
    $log.debug('User clicked create outfit');
    loadAvatarDetails().then(function success() {
      const { bodyColors } = avatarDetails;
      const assetIds = getIds(avatarDetails.assets);
      avatarService.createOutfit(outfitName, bodyColors, assetIds).then(
        function success() {
          $scope.$broadcast(avatarConstantService.events.outfitsChanged, null);
          $scope.systemFeedback.success(outfitCostumeMessage.successfulCreate);
        },
        function error(data) {
          $scope.$broadcast(avatarConstantService.events.outfitsChanged, null);
          let hasMaxOutfits =
            data &&
            data.errors &&
            data.errors[0] &&
            data.errors[0].code === avatarConstantService.outfits.outfitErrorCodes.maxOutfits;
          if (hasMaxOutfits) {
            $scope.systemFeedback.error(outfitCostumeMessage.maxNumberOfOutfits);
          } else {
            const invalidOutfitName = hasInvalidOutfitName(data);
            if (invalidOutfitName) {
              $scope.systemFeedback.error(outfitCostumeMessage.invalidOutfitName);
            } else {
              $scope.systemFeedback.error(outfitCostumeMessage.errorCreatingOutfit);
            }
          }
        }
      );
    });
  }
  function openOutfitCreateModal() {
    const modalUrl = avatarUrlConstants.modals.outfitName.templateUrl;
    const modalParams = {
      animation: false,
      templateUrl: modalUrl,
      controller: avatarUrlConstants.modals.outfitName.controllerName,
      openedClass: avatarUrlConstants.modals.openedClass,
      resolve: {
        modalData: {
          title: outfitCostumeMessage.createOutfitTitle,
          description: outfitCostumeMessage.createOutfitDescription,
          buttonName: outfitCostumeMessage.createOutfitButton,
          nameInputPlaceholder: outfitCostumeMessage.nameInputPlaceholder
        }
      }
    };
    $uibModal.open(modalParams).result.then(function(data) {
      const { outfitName } = data;
      outfitNameModalCallback(outfitName);
    });
  }

  function outfitUpdateCallback(item) {
    $log.debug('User clicked update outfit');
    // TODO provide handles for getting body colors and asset IDs instead of requesting again
    loadAvatarDetails().then(function success() {
      const { bodyColors } = avatarDetails;
      const assetIds = getIds(avatarDetails.assets);

      const outfitContents = {
        bodyColors,
        assetIds
      };

      avatarService.patchOutfit(item.id, outfitContents).then(
        function success() {
          $log.debug('Updated outfit');
          $scope.systemFeedback.success(outfitCostumeMessage.successfulUpdate);
          $scope.addItemThumbnailAndLink(item);
        },
        function error(data) {
          let outfitDoesntExist =
            data && data.errors && data.errors[0] && data.errors[0].code === 1;
          if (outfitDoesntExist) {
            $scope.systemFeedback.error(outfitCostumeMessage.updateFailedOutfitDeleted);
          } else {
            $scope.systemFeedback.error(outfitCostumeMessage.errorUpdatingOutfit);
          }
        }
      );
    });
  }
  function openOutfitUpdateModal(item) {
    const modalLayout = avatarConstantService.modalLayout.outfitUpdate;
    let outfitSingular = $scope.bundlesEnabledForUser
      ? lang.get('Label.Costume')
      : lang.get('Label.Outfit');

    const modalParams = {
      titleText: modalLayout.titlePrefix(outfitSingular),
      bodyText: modalLayout.bodyText(outfitSingular),
      actionButtonShow: true,
      actionButtonText: modalLayout.confirmBtnName,
      neutralButtonText: modalLayout.cancelBtnName,
      actionButtonId: modalLayout.confirmBtnId
    };
    modalService.open(modalParams).result.then(function(data) {
      outfitUpdateCallback(item);
    });
  }

  function outfitDeleteCallback(item) {
    $log.debug('User clicked delete outfit');

    avatarService.deleteOutfit(item.id).then(
      function success() {
        $scope.$broadcast(avatarConstantService.events.outfitDeleted, item);
        $scope.systemFeedback.success(outfitCostumeMessage.successfulDelete);
      },
      function error() {
        $scope.systemFeedback.error(outfitCostumeMessage.errorDeletingOutfit);
      }
    );
  }

  function openOutfitDeleteModal(item) {
    const modalLayout = avatarConstantService.modalLayout.outfitDelete;
    let outfitSingular = $scope.bundlesEnabledForUser
      ? lang.get('Label.Costume')
      : lang.get('Label.Outfit');
    const modalParams = {
      titleText: modalLayout.titlePrefix(outfitSingular),
      bodyText: modalLayout.bodyText(outfitSingular),
      actionButtonShow: true,
      actionButtonText: modalLayout.confirmBtnName,
      neutralButtonText: modalLayout.cancelBtnName,
      actionButtonId: modalLayout.confirmBtnId
    };
    modalService.open(modalParams).result.then(function(data) {
      outfitDeleteCallback(item);
    });
  }

  function outfitRenameCallback(item, newName) {
    $log.debug('User clicked rename outfit');

    const outfitContents = {
      name: newName
    };
    avatarService.patchOutfit(item.id, outfitContents).then(
      function success(data) {
        // update name in UI
        if (data && data.name) {
          // the API responded with a filtered version of the name
          item.name = data.name;
        } else {
          // no name included in the API response
          item.name = newName;
        }

        // show the success feedback message
        $scope.systemFeedback.success(outfitCostumeMessage.successfulRename);
      },
      function error(data) {
        const invalidOutfitName = hasInvalidOutfitName(data);
        if (invalidOutfitName) {
          $scope.systemFeedback.error(outfitCostumeMessage.invalidOutfitName);
        } else {
          $scope.systemFeedback.error(outfitCostumeMessage.errorRenamingOutfit);
        }
      }
    );
  }
  function openOutfitRenameModal(item) {
    const modalUrl = avatarUrlConstants.modals.outfitName.templateUrl;

    const modalParams = {
      animation: false,
      templateUrl: modalUrl,
      controller: avatarUrlConstants.modals.outfitName.controllerName,
      openedClass: avatarUrlConstants.modals.openedClass,
      resolve: {
        modalData: {
          title: outfitCostumeMessage.renameOutfitTitle,
          description: outfitCostumeMessage.renameOutfitDescription,
          buttonName: outfitCostumeMessage.renameOutfitButton,
          nameInputPlaceholder: outfitCostumeMessage.nameInputPlaceholder
        }
      }
    };
    $uibModal.open(modalParams).result.then(function(data) {
      outfitRenameCallback(item, data.outfitName);
    });
  }

  // Wearing Assets

  // TODO get these from avatar API site?

  function isAccessoryType(assetTypeName) {
    switch (assetTypeName) {
      case avatarAssetTypeNames.hat:
      case avatarAssetTypeNames.hairAccessory:
      case avatarAssetTypeNames.faceAccessory:
      case avatarAssetTypeNames.neckAccessory:
      case avatarAssetTypeNames.shoulderAccessory:
      case avatarAssetTypeNames.frontAccessory:
      case avatarAssetTypeNames.backAccessory:
      case avatarAssetTypeNames.waistAccessory:
        return true;
      default:
        return false;
    }
  }

  function assetTypeChangeNeedsRethumbnailing(asset) {
    switch (asset.assetType.name) {
      case avatarAssetTypeNames.climbAnimation:
      case avatarAssetTypeNames.fallAnimation:
      case avatarAssetTypeNames.jumpAnimation:
      case avatarAssetTypeNames.runAnimation:
      case avatarAssetTypeNames.swimAnimation:
      case avatarAssetTypeNames.walkAnimation:
        return false;
      default:
        // all types need it except the animation types which don't have an effect visible in AE
        return true;
    }
  }

  $scope.isAssetTypeSelectionEnabled = function(assetTypeName) {
    switch (assetTypeName) {
      case avatarAssetTypeNames.emoteAnimation:
        return false;
      default:
        // All types except emotes
        return true;
    }
  };

  $scope.showAdvancedAccessoriesLink = true;

  function updateAdvancedAccessoriesLinkVisibility() {
    const menu = $scope.selectedMenu;
    $scope.showAdvancedAccessoriesLink = menu && menu.assetType && isAccessoryType(menu.assetType);
  }

  function showAccessoriesDoubleCheckPrompt() {
    let modalParams = {};
    const modalLayout = avatarConstantService.modalLayout.advancedAccessoriesDoubleCheck;
    modalParams = {
      titleText: modalLayout.title,
      bodyText: modalLayout.bodyText,
      actionButtonShow: true,
      actionButtonText: modalLayout.confirmBtnName,
      neutralButtonText: modalLayout.cancelBtnName
    };
    const modal = modalService.open(modalParams).result;
    return modal;
  }

  function onSaveAdvancedAccessories(otherAssets, advancedAccessorySlots, submitFunc) {
    const doubleCheckModal = showAccessoriesDoubleCheckPrompt();
    $log.debug(doubleCheckModal);
    doubleCheckModal.then(
      function onSave() {
        $log.debug('Confirmed double check modal');

        // validate all inputs
        const assetIds = [];
        angular.forEach(advancedAccessorySlots, function(slot) {
          if (slot.id !== '') {
            assetIds.push(slot.id);
          }
        });

        // add other assets
        angular.forEach(otherAssets, function(asset) {
          assetIds.push(asset.id);
        });

        setWearingAssetsFromIds(assetIds, true).then(
          function success(response) {
            // leave the modal open and update the form fields to show valid/invalid
            if (response && response.invalidAssetIds && response.invalidAssetIds.length > 0) {
              const { invalidAssetIds } = response;
              // mark them as dirty
              $log.debug(invalidAssetIds);
              angular.forEach(advancedAccessorySlots, function(accessorySlot) {
                $log.debug(accessorySlot);
                let valid =
                  accessorySlot.id === '' ||
                  invalidAssetIds.indexOf(parseInt(accessorySlot.id)) === -1;
                // update valid state
                accessorySlot.valid = valid;
              });
              googleAnalyticsEventsService.fireEvent(
                avatarConstantService.googleAnalytics.category,
                avatarConstantService.googleAnalytics.advancedAccessoriesAction,
                avatarConstantService.googleAnalytics.saveFailedLabel
              );
            } else {
              $scope.systemFeedback.success(avatarConstantService.assets.savedAdvancedAccessories);
              $log.debug('Successfully saved advanced assets');
              submitFunc();
              googleAnalyticsEventsService.fireEvent(
                avatarConstantService.googleAnalytics.category,
                avatarConstantService.googleAnalytics.advancedAccessoriesAction,
                avatarConstantService.googleAnalytics.saveLabel
              );
            }
          },
          function error(response) {
            // something really wrong
            $scope.systemFeedback.error(avatarConstantService.assets.errorUpdatingItems);
          }
        );
      },
      function cancel() {
        $log.debug('Cancelled double check modal');
      }
    );
  }

  $scope.openAdvancedAccessories = function() {
    const modalUrl = avatarUrlConstants.modals.advancedAccessories.templateUrl;

    const advancedAccessorySlots = [];
    const otherAssets = [];

    // add existing assets
    angular.forEach(currentlyWornAssets, function(asset) {
      if (isAccessoryType(asset.assetType.name)) {
        advancedAccessorySlots.push({
          id: asset.id,
          valid: true
        });
      } else {
        otherAssets.push(asset);
      }
    });

    // fill in rest of 10 slots
    for (let i = 0; i < 10; i++) {
      if (typeof advancedAccessorySlots[i] === 'undefined') {
        advancedAccessorySlots[i] = { id: '', valid: true };
      }
    }

    const catalogUrlRegex = /catalog\/(\d+)/i;
    const idRegex = /^\d+$/i;

    function isValidId(id) {
      return idRegex.exec(id) !== null;
    }

    function getIdFromCatalogUrl(url) {
      let match = catalogUrlRegex.exec(url);
      if (match !== null && match[1]) {
        return match[1];
      }
      return null;
    }
    const modalData = {
      advancedAccessorySlots,
      onChange(slot) {
        let catalogUrl = getIdFromCatalogUrl(slot.id);
        if (catalogUrl !== null) {
          slot.id = catalogUrl;
        }

        slot.valid = slot.id === '' || isValidId(slot.id);
      },
      onSaveClick(submitFunc) {
        $log.debug('submitFunc', submitFunc);
        onSaveAdvancedAccessories(otherAssets, advancedAccessorySlots, submitFunc);
      }
    };
    const modalParams = {
      animation: false,
      templateUrl: modalUrl,
      controller: avatarUrlConstants.modals.advancedAccessories.controllerName,
      openedClass: avatarUrlConstants.modals.openedClass,
      resolve: {
        modalData
      }
    };
    $uibModal.open(modalParams).result.then(
      function() {
        $log.debug('User clicked save assets in advanced view');
      },
      function() {
        $log.debug('User cancelled out of assets advanced view');
        googleAnalyticsEventsService.fireEvent(
          avatarConstantService.googleAnalytics.category,
          avatarConstantService.googleAnalytics.advancedAccessoriesAction,
          avatarConstantService.googleAnalytics.closeLabel
        );
      }
    );
    googleAnalyticsEventsService.fireEvent(
      avatarConstantService.googleAnalytics.category,
      avatarConstantService.googleAnalytics.advancedAccessoriesAction,
      avatarConstantService.googleAnalytics.openLabel
    );
  };

  // / Avatar Items

  $scope.onItemClicked = function(item, $event) {
    $event.preventDefault();

    if (item.type === 'Outfit') {
      wearOutfit(item);
    } else if (item.type === 'Asset') {
      if ($scope.emotesEnabledForUser) {
        let emoteAssetType = avatarTypeService.getAssetTypeByName(['Emote Animation']);
        if (
          item.assetType !== null &&
          emoteAssetType !== null &&
          item.assetType.id === emoteAssetType.id
        ) {
          // Don't equip emotes, instead show modal with emote already selected
          $scope.openEmotesModal(item);
          return;
        }
      }

      if (item.assetType.name === 'Package') {
        wearPackageAsset(item);
        return;
      }

      if (!item.selected) {
        item.selected = true;
        wearAsset(item);
      } else {
        item.selected = false;
        removeAsset(item);
      }
    }
  };

  $scope.addItemThumbnailAndLink = function(item) {
    item.thumbnail = {
      Final: false,
      Url: ''
    };
    switch (item.type) {
      case 'Asset':
        item.thumbnailType = thumbnailConstants.thumbnailTypes.assetThumbnail;
        item.link = Endpoints.getCatalogItemUrl(item.id, item.name);
        break;
      case 'Outfit':
        item.thumbnailType = thumbnailConstants.thumbnailTypes.userOutfit;
        break;
    }
  };

  // Hat Slots

  $scope.hatSlots = [];

  $scope.onHatSlotClicked = function(item) {
    removeAsset(item);
  };

  function updateHatSlots(assets) {
    const hatSlots = [];

    const max = 3;
    let count = 0;
    angular.forEach(assets, function(asset) {
      if (count >= max) {
        return;
      }
      if (asset.assetType.name === 'Hat') {
        const slot = {};
        slot.type = 'Asset';
        angular.extend(slot, asset);
        $scope.addItemThumbnailAndLink(slot);
        count++;
        hatSlots.push(slot);
      }
    });

    while (count < max) {
      count++;
      hatSlots.push({ empty: true });
    }

    $scope.hatSlots = hatSlots;
  }

  // / Avatar State

  var currentlyWornAssets = [];
  let currentlyWornAssetsLookup = [];

  $scope.updateItemSelected = function(item) {
    item.selected = item.type === 'Asset' && currentlyWornAssetsLookup[item.id] === true;
  };

  function getIds(assets) {
    const ids = [];
    angular.forEach(assets, function(asset) {
      ids.push(asset.id);
    });
    return ids;
  }

  function getIdsLookup(assets) {
    const ids = getIds(assets);
    const lookup = {};
    angular.forEach(ids, function(id) {
      lookup[id] = true;
    });
    return lookup;
  }

  function maxOfAssetType(assetTypeId) {
    const assetType = getAssetType(assetTypeId);
    let maxNumber = assetType ? assetType.maxNumber : 1;
    return maxNumber;
  }

  function setCurrentlyWornAssets(assets) {
    currentlyWornAssets = assets;
    currentlyWornAssetsLookup = getIdsLookup(assets);
  }

  function updateSelection() {
    const assetIds = getIds(currentlyWornAssets);
    $scope.$broadcast(avatarConstantService.events.wornAssetsChanged, assetIds);
    updateHatSlots(currentlyWornAssets);
  }

  function wearOutfit(item) {
    avatarService.wearOutfit(item.id).then(
      function success(data) {
        $scope.refreshThumbnail();
        loadAvatarDetails();

        let anyInvalidAssets = data && data.invalidAssetIds && data.invalidAssetIds.length > 0;
        if (anyInvalidAssets) {
          const count = data.invalidAssetIds.length;
          const message = avatarConstantService.outfits.missingItemsFromOutfit(count.toString());
          $scope.systemFeedback.error(message);
        } else {
          $scope.systemFeedback.success(outfitCostumeMessage.successfulWear);
        }
      },
      function error() {
        $scope.systemFeedback.error(outfitCostumeMessage.errorWearingOutfit);
      }
    );
  }

  let updateThumbnailAfterSet = true;

  function setWearingAssetsFromIds(assetIds, reloadAssetsAfterSuccess) {
    const request = avatarService.setWearingAssets(assetIds);
    request.then(
      function success() {
        $log.debug('Success with set-wearing-assets');

        if (updateThumbnailAfterSet) {
          $scope.refreshThumbnail();
        } else {
          updateThumbnailAfterSet = true;
        }

        // we reload assets after success in advanced view because we only know the asset IDs
        // we don't know anything else about the assets or their types
        if (reloadAssetsAfterSuccess) {
          loadAvatarDetails();
        }
      },
      function error() {
        $log.debug('Error with set-wearing-assets');
      }
    );
    return request;
  }

  function setWearingAssets(assets) {
    const currentAssets = currentlyWornAssets;
    setCurrentlyWornAssets(assets);
    updateSelection();

    const assetIds = getIds(currentlyWornAssets);
    const reloadAssetsAfterSuccess = false;
    const request = setWearingAssetsFromIds(assetIds, reloadAssetsAfterSuccess);
    request.then(
      function success() {},
      function error() {
        $scope.systemFeedback.error(avatarConstantService.assets.errorUpdatingItems);
        // Undo local selection back to what it was before
        setCurrentlyWornAssets(currentAssets);
        updateSelection();
      }
    );
    return request;
  }

  function wearPackageAsset(item) {
    avatarService.wearAsset(item.id).then(
      function success(data) {
        $scope.refreshThumbnail();
        loadAvatarDetails();

        let anyInvalidAssets = data && data.invalidAssetIds && data.invalidAssetIds.length > 0;
        if (anyInvalidAssets) {
          const count = data.invalidAssetIds.length;
          const message = avatarConstantService.outfits.missingItemsFromOutfit(count.toString());
          $scope.systemFeedback.error(message);
        }
      },
      function error() {
        $scope.systemFeedback.error(avatarConstantService.packages.errorWearingPackage);
      }
    );
  }

  function wearAsset(assetToWear) {
    const filteredAssets = [];
    const count = {};
    const isAddingAccessory = isAccessoryType(assetToWear.assetType.name);

    function getBucket(assetType) {
      if (!isAddingAccessory && isAccessoryType(assetType.name)) {
        return 'Accessory';
      }
      return assetType.name;
    }

    // if adding an accessory, use the regular wearing limits
    // otherwise use the 10 accessory limit

    function add(asset) {
      const { assetType } = asset;
      let max =
        !isAddingAccessory && isAccessoryType(assetType.name)
          ? avatarConstantService.assets.maxAccessories
          : maxOfAssetType(assetType.id);
      const bucket = getBucket(asset.assetType);
      count[bucket] = typeof count[bucket] === 'undefined' ? 0 : count[bucket];
      if (count[bucket] < max) {
        count[bucket] += 1;
        filteredAssets.push(asset);
      } else {
        $log.debug(`Removed asset ${  asset.name  } because it exceeded wearing limits`);
      }
    }

    add(assetToWear);

    angular.forEach(currentlyWornAssets, function(asset) {
      add(asset);
    });

    // don't refresh thumbnail if we're changing a type which has no visible effect.
    updateThumbnailAfterSet = assetTypeChangeNeedsRethumbnailing(assetToWear);

    return setWearingAssets(filteredAssets);
  }

  function removeAsset(assetToRemove) {
    const filteredAssets = [];

    angular.forEach(currentlyWornAssets, function(asset) {
      if (asset.id !== assetToRemove.id) {
        filteredAssets.push(asset);
      }
    });

    // don't refresh thumbnail if we're changing a type which has no visible effect.
    updateThumbnailAfterSet = assetTypeChangeNeedsRethumbnailing(assetToRemove);

    return setWearingAssets(filteredAssets);
  }

  // / Default Clothing

  $scope.toastLayout = {
    isNeeded: false,
    timeout: avatarConstantService.defaultClothing.displayTimeInMilliseconds,
    text: avatarConstantService.defaultClothing.wearClothing
  };
  let lastNeedsDefaultValue = null;
  let bodyColorsCopyForDefaultClothing = null;
  let firstTimeCheckingDefaults = true;

  function colorIdToRgb(colorId) {
    let hexColor = '#000000';
    for (let i = 0; i < avatarRules.bodyColorsPalette.length; i++) {
      const bodyColor = avatarRules.bodyColorsPalette[i];
      if (bodyColor.brickColorId === colorId) {
        hexColor = bodyColor.hexColor;
      }
    }

    const hexColorParsed = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
    if (hexColorParsed === null) {
      throw new Error(
        `Unable to parse bodyColor with ID=${  colorId  } and retrieved hex=${  hexColor}`
      );
    }

    return {
      R: parseInt(hexColorParsed[1], 16),
      G: parseInt(hexColorParsed[2], 16),
      B: parseInt(hexColorParsed[3], 16)
    };
  }

  function bodyColorsTooSimilar(firstBodyColorId, secondBodyColorId) {
    const firstBodyColorRgb = colorIdToRgb(firstBodyColorId);
    const secondBodyColorRgb = colorIdToRgb(secondBodyColorId);

    const deltaE = avatarBodyColorDifference.DeltaE(firstBodyColorRgb, secondBodyColorRgb);
    return deltaE < avatarRules.minimumDeltaEBodyColorDifference;
  }

  function bodyColorsQualifyForDefaultClothing(bodyColors) {
    let lowerBodySameColors =
      bodyColors.torsoColorId === bodyColors.leftLegColorId &&
      bodyColors.leftLegColorId === bodyColors.rightLegColorId;

    if ($scope.avatarDataModel.defaultClothingForSimilarColorsEnabled) {
      return (
        lowerBodySameColors ||
        bodyColorsTooSimilar(bodyColors.torsoColorId, bodyColors.rightLegColorId) ||
        bodyColorsTooSimilar(bodyColors.torsoColorId, bodyColors.leftLegColorId)
      );
    }

    return lowerBodySameColors;
  }

  function isWearingAssetOfType(assetTypeName) {
    for (let i = 0; i < currentlyWornAssets.length; i++) {
      const asset = currentlyWornAssets[i];
      if (asset.assetType.name === assetTypeName) {
        return true;
      }
    }
    return false;
  }

  function needsDefaultClothing(bodyColors) {
    if (bodyColors === null || avatarDetails === null) {
      return false;
    }

    if (!bodyColorsQualifyForDefaultClothing(bodyColors)) {
      return false;
    }

    let wearingPants = isWearingAssetOfType('Pants');
    if (wearingPants) {
      return false;
    }

    return true;
  }

  function checkDefaults() {
    if ($scope.avatarDataModel === null) {
      return;
    }

    if (!$scope.avatarDataModel.enableDefaultClothingMessage) {
      return;
    }

    // check if we need to display the overlay on page load
    if (firstTimeCheckingDefaults && !$scope.avatarDataModel.showDefaultClothingMessageOnPageLoad) {
      firstTimeCheckingDefaults = false;
      return;
    }

    const needsDefault = needsDefaultClothing(bodyColorsCopyForDefaultClothing);

    const changedSinceLastCheck = lastNeedsDefaultValue !== needsDefault;
    lastNeedsDefaultValue = needsDefault;

    // only trigger visibility if the status changes for needsDefault
    // e.g. if you are just switching around assets, we don't want to pop up the default clothing overlay every time

    if (needsDefault && changedSinceLastCheck) {
      $scope.toastLayout.isNeeded = true;
    }
  }

  var getCategories = function() {
    return avatarService.getCategories().then(function success(result) {
      $scope.categoryDict = result;
    });
  };
  var getSubcategories = function() {
    return avatarService.getSubcategories().then(function success(result) {
      $scope.subcategoryDict = result;
    });
  };

  $scope.$on(avatarConstantService.events.avatarDetailsLoaded, function(event, avatarDetails) {
    bodyColorsCopyForDefaultClothing = avatarDetails.bodyColors;
    checkDefaults();
  });

  $rootScope.$on(avatarConstantService.events.bodyColorsChanged, function(event, bodyColors) {
    bodyColorsCopyForDefaultClothing = bodyColors;
    checkDefaults();
  });

  // wornAssetsChanged fires once on initial page load, ignore the first one
  let firstWornAssetsChanged = true;
  $scope.$on(avatarConstantService.events.wornAssetsChanged, function(event, assetIds) {
    if (firstWornAssetsChanged) {
      firstWornAssetsChanged = false;
      return;
    }
    checkDefaults();
  });

  // Init

  const tab = $scope.tabs[0];
  const menu = tab.subCategoryMenu ? tab.subCategoryMenu[0] : tab.categoryRows[0].subCategoryMenu[0];
  $scope.onMenuClick(tab, menu);

  $scope.loadAvatarPage();
  updateAdvancedAccessoriesLinkVisibility();

  $scope.pageFocused = function(idleSeconds) {
    $log.debug("Page didn't have focus for ", idleSeconds);
    if (idleSeconds > avatarConstantService.page.idleRefreshTimeInSeconds) {
      // TODO check avatar details to see if any have changed before reloading
      loadAvatarDetails();
      $scope.refreshThumbnail();
    }
  };
}

avatarModule.controller('avatarController', avatarController);

export default avatarController;
